<template>
  <w-icon-wrapper icon-name='work-download-icon'>
    <g
      id="_122_ZIP_Download"
      data-name="122_ZIP_Download"
      transform="translate(-940 321)"
    >
      <path
        id="Pfad_7"
        data-name="Pfad 7"
        d="M14,0H0V24H5.87a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H2V2H12V8h6v6.63a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1V6Zm0,6V2.83L17.17,6Z"
        transform="translate(940 -321)"
        fill="currentColor"
      />
      <g
        id="Gruppe_3"
        data-name="Gruppe 3"
        transform="translate(940 -321)"
      >
        <path
          id="Pfad_8"
          data-name="Pfad 8"
          d="M10.52,23.01h3.02V24H8.97v-.73L11.94,19H8.98V18h4.5v.71l-2.96,4.3Z"
          fill="currentColor"
        />
        <path
          id="Pfad_9"
          data-name="Pfad 9"
          d="M15.64,24.01H14.4v-6h1.24Z"
          fill="currentColor"
        />
        <path
          id="Pfad_10"
          data-name="Pfad 10"
          d="M18.02,21.89V24H16.78V18h2.34a2.638,2.638,0,0,1,1.19.25,1.863,1.863,0,0,1,.79.7,2,2,0,0,1,.28,1.04,1.724,1.724,0,0,1-.6,1.39,2.506,2.506,0,0,1-1.67.51H18.03Zm0-1h1.1a1.1,1.1,0,0,0,.75-.23.836.836,0,0,0,.26-.66,1,1,0,0,0-.26-.71.986.986,0,0,0-.72-.28H18.02v1.88Z"
          fill="currentColor"
        />
      </g>
      <path
        id="Pfad_11"
        data-name="Pfad 11"
        d="M9.94,16.34l.53-.54.06-.06,2.24-2.28a.785.785,0,0,0,0-1.1.74.74,0,0,0-1.07,0l-.98,1V8.91a.76.76,0,1,0-1.52,0v4.44l-.97-1.02a.749.749,0,0,0-1.07-.02.787.787,0,0,0-.23.56.764.764,0,0,0,.21.54l2.78,2.93Z"
        transform="translate(940 -321)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDownloadZip' };
</script>
